<style lang='scss'>
	#main-handhome{
		.ant-modal {
			top: 5vh;
		}
		.ant-modal-header, .ant-modal-body{
			background-color: #e5e5e5 !important;
			padding: 1rem;
			padding-top: .7rem;
			border-radius: 0;
		}
		.main-hand-title{
			position: absolute;
			top: 0;
			left: 0;
			div{
				font-size: 1rem;
				padding: .8rem 1rem .2rem 1rem;
				background-color:  #e5e5e5;
			}
		}
		.wland{
			display: inline-block;
			width: 7rem;
			padding: .4rem 0 .6rem;
			text-align: center;
			background-color: #fff;
			color: #000;
			border-top: .2rem solid #e99c00;
			border-right: 1px solid #e5e5e5;
			font-size: .8rem;
		}
		.gland{
			display: inline-block;
			width: 7rem;
			padding: .6rem 0;
			text-align: center;
			background-color: #0c8b97;
			color: #fff;
			font-size: .8rem;
			border-right: 1px solid #e5e5e5;
		}
	}
	#mybody-main>div{
		padding: .4rem 0;
	}
	#mybody-main{
		background-color: #fff;
		.main-mybody{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			height: 32rem;
		}
		.main-mybody1{
			padding: .5rem 1.5rem 0;
			overflow-y: auto;
			height: 37rem;
		}
		.look_g{
			font-size: .9rem;
			margin-bottom: .5rem;
			color: #0c8b97;
			div{
				display: inline-block;
				width: 1px;
				height: .9rem;
				position: relative;
				top: .1rem;
				margin-right: .2rem;
				border-left: 3px solid #0c8b97;
			}
		}
		.main-wid{
			width: 100%;
			height: 1px;
			border-top: .5px solid #d8d8d8;
			margin: 1rem 0;
		}
		.ant-col {
			font-size: .8rem;
			color: #000;
			margin: .4rem 0;
		}
		.btn-main{
			cursor: pointer;
			width: 6rem;
			height: 2rem;
			line-height: 2rem;    
			text-align: center;
			font-size: .8rem;
			color: #fff;
			border: 0;
			background-color: #0c8b97;
		}
		.btn-main1{
			margin: 0 1rem;
			background-color: #c8c8c8;
		}
	}
</style>
<template>
	<div>
		<a-modal
		width='40rem'
		id='main-handhome'
		title='title'
		v-model='visible'
		@on='handleOk'
		@cancel='handleCancel'
		:footer="null" 
		:keyboard='false'
		:dialog-style="{top: 22 +'%'}"
		:maskClosable='false'>
			<div class='main-hand-title'>
				<div style="padding-top:1.2rem">股票派息</div>
			</div>
			<div v-for='(item,ind) in titlearr' style="cursor: pointer;" :key='ind + "0716"' :class='ind_val == item.id ?"wland":"gland"' @click="fanfn(item.id)">
				{{item.name}}
			</div>
			<div id='mybody-main'>
				<handhome1 v-if="(ind_val == 0)" :isval="forms" :father="this"></handhome1>
				<handhome2 v-if="(ind_val == 1)" :isval="forms" :father="this"></handhome2>
				<handhome3 v-if="(ind_val == 2)" :isval="forms" :father="this"></handhome3>
			</div>
		</a-modal>
	</div>
</template>

<script>
	import handhome1 from './handhome1.vue'
	import handhome2 from './handhome2.vue'
	import handhome3 from './handhome3.vue'
		
	export default {
		name:'handhome',
		props:['forms'],
		components:{
			handhome1,
			handhome2,
			handhome3,
		},
		data(){
			return {
				lookfrom:{},
				ind_val:0,
				visible:true,
				dividendsedit : this.$store.state.rolesdata.indexOf('dividendsedit') >= 0,
				titlearr:[
					{
						name:'帳號 : '+ this.forms.username,
						island:true,
						id:0
					},{
						name:'添加派息',
						island:false,
						id:1
					},{
						name:'派息審批',
						island:false,
						id:2
					}
				]
			
			}
		},
		mounted() {
			console.log(this.dividendsedit);
			if (!this.forms.auditid) {
				this.titlearr = [
					{
						name:'帳號 : '+ this.forms.username,
						island:true,
						id:0
					},{
						name:'添加派息',
						island:false,
						id:1
					}
				]
				
			
			}
			if (!this.dividendsedit) {
				this.titlearr = [
					{
						name:'帳號 : '+ this.forms.username,
						island:true,
						id:0
					},{
						name:'派息審批',
						island:false,
						id:2
					}
				]
			}
		},
		methods:{
			fanfn(val){
				this.ind_val = val
			},
			handleOk(){
				
			},
			handleCancel(){
				this.$emit('child', 0)

			},
		}
	}
</script>
